var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalRetificacao
        ? _c("app-modal-cancelar-retificacao", {
            attrs: {
              idProcesso: _vm.idProcesso,
              numeroProcesso: _vm.numeroProcesso,
              setor: _vm.setor
            },
            on: { closeModal: _vm.closeRetificacao }
          })
        : _vm._e(),
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _vm.showModalSuspensaoProcesso
        ? _c("modal-suspensao-processo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              numeroProcesso: _vm.numeroProcesso,
              caixaSuspensao: false,
              setor: _vm.setor,
              sIndireta: _vm.sIndireta
            },
            on: {
              closeModal: function($event) {
                _vm.showModalSuspensaoProcesso = false
              },
              refresh: _vm.refresh
            }
          })
        : _vm._e(),
      _vm.showModalDespacho
        ? _c("app-modal-analise-conjunta", {
            attrs: {
              idsProcessos: _vm.idsProcessosValidacao,
              showModal: _vm.showModalDespacho,
              analiseSemDespacho: _vm.analiseSemDespacho,
              titulo: "Modelos de Despacho Dinâmico",
              tiposModelo: [4]
            },
            on: {
              closeModal: _vm.closeModalDespacho,
              cancelModal: _vm.closeModalDespacho,
              confirm: _vm.confirmarModelo,
              filtro: _vm.closeModalDespacho,
              cancelaTramitacao: _vm.cancelaTramitacao
            }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              configuracaoFiltro: _vm.configuracaoFiltro,
              filtroRapido: _vm.filtroRapido,
              showFiltroTipoMultiplo: _vm.showFiltroTipoMultiplo
            },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.clear }
          })
        ],
        1
      ),
      _vm.exibirListagem
        ? _c("app-listagem", {
            attrs: {
              "has-refresh-button": true,
              showValidacaoColetiva: _vm.isPa && _vm.isDeaf,
              hasMultipleCheckbox: _vm.isPa && _vm.isDeaf,
              idsDisabledCheckbox: _vm.processosCheckboxDisabled,
              processosSelecionados: _vm.processosColetivosSelecionados,
              showButtonOrdemServico: false,
              showButtonAssinatura: false,
              textoButtonAssinatura: _vm.textoButtonAssinatura,
              "has-expansivel": false,
              "json-headers": _vm.colunas,
              "json-data": _vm.items,
              totalElements: _vm.totalElements,
              pagina: _vm.filtro.pagina,
              hasFiltroRapido: true,
              filtro: _vm.filtro,
              infoPrazos: _vm.showInfoVencimento() && _vm.infoPrazos
            },
            on: {
              assinarTitulos: _vm.validarProcessosColetivos,
              selectAll: _vm.changeProcessosColetivosSelecionados,
              atualizarFiltro: _vm.atualizarFiltro,
              updateListagem: _vm.refresh,
              changePage: _vm.changePage,
              sort: _vm.sort,
              exportarCsvFiltroAnalise: _vm.exportarCsvFiltroAnalise,
              executar: _vm.executar,
              selected: false
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-387187a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-387187a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/listagem/AguardandoValidacaoListagem.vue
// module id = null
// module chunks = 